import { RootState } from '../../../root.reducer';

export const getReferralCode = (state: RootState) => state.register.referralCode;
export const getIsLoadingRegister = (state: RootState) => state.register.isLoading;
export const getRegisterError = (state: RootState) => state.register.error;
export const getCurrentStep = (state: RootState) => state.register.currentStep;
